app.filter('highlightYellow', ['$sce', function($sce) {
  return function(text, search) {
    if (!search) {
      return $sce.trustAsHtml(text);
    }
    var regex = new RegExp('(' + search + ')', 'gi');
    var highlighted = text.replace(regex, '<span class="yellow-highlighted">$1</span>');
    return $sce.trustAsHtml(highlighted);
  };
}]);